import { AxiosInstance } from "axios"

export type InternalUser = Readonly<{
    email: string
    roles?: string[]
    company?: {
        isAgreementOwner?: boolean
    }
}>

export type InternalUsersResponse = Readonly<{
    users: InternalUser[]
}>

type FetchInternalUsersParams = Readonly<{
    userTypes: string
    userIsActive: string
    originalUserTypes?: string[] // For filtering in onSuccess
}>

export async function fetchInternalUsers(
    params: FetchInternalUsersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<InternalUsersResponse> {
    const { userTypes, userIsActive } = params

    const url = "/internal/users"
    const { data } = await axios.get(url, {
        params: {
            userTypes,
            userIsActive,
        },
        signal,
    })

    return data
}

